import axios from 'axios';
import { polyfill } from 'es6-promise';
import IApiSharePointResponse from '../interfaces/IApiSharePointResponse';
import ICandidature from '../interfaces/ICandidature';
import { ICandidaturePJResp } from '../interfaces/ICandidaturePJResp';
import IPromotion from '../interfaces/IPromotion';
declare var configcustoms: any;


export default class DataProviderSharePoint {

    private serverWSURL: string = configcustoms.UrlSharePointAPI;
    private apiCandidatureByLogin: string = configcustoms.SharePointAPI.CandidatureByLogin;
    private apiPromotionOpened: string = configcustoms.SharePointAPI.PromotionOpened;
    private apiCreateCandidature: string = configcustoms.SharePointAPI.CreateCandidature;
    private apiSendInput: string = configcustoms.SharePointAPI.SendInput;
    private apiGetInput: string = configcustoms.SharePointAPI.GetInput;
    private apiGetInputValue: string = configcustoms.SharePointAPI.GetInputValue;
    private apiGetAllCustomInput: string = configcustoms.SharePointAPI.GetAllCustomInput;
    private apiGetPJList: string = configcustoms.SharePointAPI.GetPJList;
    private apiUploadPJ: string = configcustoms.SharePointAPI.UploadPJ;
    private apiDeletePJ: string = configcustoms.SharePointAPI.DeletePJ;
    private apiDownloadPJ: string = configcustoms.SharePointAPI.DownloadPJ;

    constructor() {
        polyfill();
    }

    public async getPromotionOpened(): Promise<IApiSharePointResponse<IPromotion>> {
        let rtn: IApiSharePointResponse<IPromotion> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiPromotionOpened,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'get'
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async getCandidaturesByLogin(login: string): Promise<IApiSharePointResponse<ICandidature>> {
        let rtn: IApiSharePointResponse<ICandidature> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiCandidatureByLogin,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: {
                    LoginName: login,
                    Fields: "*"
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async createCandidature(login: string, promotionId: number): Promise<IApiSharePointResponse<void>> {
        let rtn: IApiSharePointResponse<void> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiCreateCandidature,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: {
                    LoginName: login,
                    PromotionValue: promotionId
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async sendInput(login: string, candidatureId: number, fieldInternalName: string, value: string, type: string): Promise<IApiSharePointResponse<void>> {
        let rtn: IApiSharePointResponse<void> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiSendInput,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: {
                    LoginName: login,
                    IDCandidature: candidatureId,
                    FieldName: fieldInternalName,
                    Value: value,
                    Type: type
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async getInput(fieldInternalName: string): Promise<IApiSharePointResponse<any>> {
        let rtn: IApiSharePointResponse<any> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiGetInput,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: {
                    Name: fieldInternalName
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async getAllCustomInput(): Promise<IApiSharePointResponse<any>> {
        let rtn: IApiSharePointResponse<any> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiGetAllCustomInput,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'get'
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async getInputValue(login: string, fieldInternalName: string, candidatureId: number): Promise<IApiSharePointResponse<any>> {
        let rtn: IApiSharePointResponse<any> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiGetInputValue,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: {
                    LoginName: login,
                    Fields: fieldInternalName,
                    IDCandidature: candidatureId
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async getPJList(login: string, candidatureId: number): Promise<IApiSharePointResponse<ICandidaturePJResp>> {
        let rtn: IApiSharePointResponse<ICandidaturePJResp> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiGetPJList,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'post',
                data: {
                    LoginName: login,
                    IDCandidature: candidatureId
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async uploadPJ(login: string, candidatureId: number, fileName: string, file: any): Promise<IApiSharePointResponse<void>> {
        let rtn: IApiSharePointResponse<void> = { OK: false, Message: '', List: [] };

        const bodyFormData = new FormData();
        bodyFormData.append("LoginName", login);
        bodyFormData.append("IDCandidature", '' + candidatureId);
        bodyFormData.append("FileName", fileName);
        bodyFormData.append("File", file);

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiUploadPJ,
                headers: { 
                    'Access-Control-Allow-Origin': window.location.href,
                    'Content-Type': 'multipart/form-data'
                },
                method: 'post',
                data: bodyFormData,
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async deletePJ(login: string, candidatureId: number, fileName: string): Promise<IApiSharePointResponse<void>> {
        let rtn: IApiSharePointResponse<void> = { OK: false, Message: '', List: [] };

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiDeletePJ,
                headers: { 'Access-Control-Allow-Origin': window.location.href },
                method: 'delete',
                data: {
                    LoginName: login,
                    IDCandidature: candidatureId,
                    FileName: fileName
                }
            });
            rtn = resp.data;
            return rtn;
        }
        catch (error) {
            rtn.OK = false;
            rtn.Message = error;
            return rtn;
        }
    }

    public async downloadPJ(login: string, candidatureId: number, fileName: string): Promise<any> {
        const FileSaver = require('file-saver');
        const MimeTypes = require('mime-types');

        try {
            const resp = await axios({
                url: this.serverWSURL + this.apiDownloadPJ,
                headers: { 'Access-Control-Allow-Origin': window.location.href, },
                responseType: 'blob',
                method: 'post',
                data: {
                    LoginName: login,
                    IDCandidature: candidatureId,
                    FileName: fileName
                }
            });

            const mime = MimeTypes.lookup(fileName.split('.').pop());
            if(mime == null || mime === false) {
                return;
            }

            // Create blob with mime type
            const blob = new Blob([resp.data], {type : mime});
            FileSaver.saveAs(blob, fileName);
        }
        catch (error) {
            return 'Error download';
        }
    }

}
